export default angular
  .module('app.formatting')
  .filter('holdingFormatPercentage', holdingFormatPercentage)
  .name;

function holdingFormatPercentage() {
  'ngInject';

  return formatPercentage;

  function formatPercentage(input, hasSign = true) {
    const number = parseFloat(input);
    if (isNaN(number)) {
      return '';
    }

    let sign = '';
    if (hasSign) {
      sign = number > 0 ? '+' : '';
    }
    return `${sign}${number.toFixed(2)}%`;
  }
}



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/formatting/filters/format-percentage.js